// src/CybersourcePostHandler.jsx
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const CybersourcePostHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Only run on /response and only when Cybersource POSTed
    if (location.pathname !== '/response') return;
    if (!document.referrer.includes('cybersource.com')) return;

    // Grab ALL hidden inputs Cybersource sent
    const params = new URLSearchParams();
    document.querySelectorAll('input[name]').forEach(input => {
      if (input.name && input.value !== undefined) {
        params.set(input.name, input.value);
      }
    });

    // Convert POST → clean GET instantly (no page flash)
    if (params.toString()) {
      navigate(`/response?${params.toString()}`, { replace: true });
    }
  }, [navigate, location]);

  // This component is invisible
  return null;
};

export default CybersourcePostHandler;